import { useEffect } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import AddTodoForm from "./AddTodoForm/AddTodoForm";
import { TodoContext } from "./context/TodoContext";
import { resumeFaites } from "./resumeTaches";
import TodoItem from "./TodoItem/TodoItem";
import useTodoList from "./useTodoList";
import "./todoList.scss";

// Lu par les lecteurs d'écran quand une poignée reçoit le focus.
const INSTRUCTIONS_POIGNEE =
  "Appuyez sur Espace pour saisir la tâche, déplacez-la avec les flèches haut et bas, puis Espace pour la poser. Échap annule.";

// Liste des tâches d'un lead : une ligne par tâche (poignée, case, nom, note,
// qui et quand), réordonnable, puis l'ajout. Les actions (cocher, réordonner,
// modifier, ajouter, supprimer) sont celles de la page qui l'affiche.
const TodoList = ({ initTodos, tasksByProduct, onUpdateTodos, onUpdateTodo, onAddTodo, onDeleteTodo, users }) => {
  const { todos, setupTodos, actions } = useTodoList(onUpdateTodos, onUpdateTodo, onAddTodo, onDeleteTodo);

  useEffect(() => {
    setupTodos(initTodos, tasksByProduct, users);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initTodos]);

  const handleOnDragEnd = (result) => {
    if (!result.destination || result.destination.index === result.source.index) {
      return;
    }
    const items = Array.from(todos);
    const [deplacee] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, deplacee);
    actions.updateTodos(items);
  };

  return (
    <div className="tl">
      {todos.length > 0 ? (
        <div className="tl-tete">{resumeFaites(todos)}</div>
      ) : (
        <p className="tl-vide">Aucune tâche sur ce lead.</p>
      )}
      <DragDropContext onDragEnd={handleOnDragEnd} dragHandleUsageInstructions={INSTRUCTIONS_POIGNEE}>
        <Droppable droppableId="tasks" type="TASKS">
          {(provided) => (
            <ol className="tl-liste" {...provided.droppableProps} ref={provided.innerRef}>
              {/* La poignée est un bouton : sans disableInteractiveElementBlocking,
                  react-beautiful-dnd refuse un glissement depuis un élément interactif. */}
              {todos.map((todo, index) => (
                <Draggable key={`todo${todo.id}`} draggableId={`todo${todo.id}`} index={index} disableInteractiveElementBlocking>
                  {(fourni, etat) => (
                    <li
                      className={`tl-tache${todo.isDone ? " tl-tache--faite" : ""}${etat.isDragging ? " tl-tache--glissee" : ""}`}
                      ref={fourni.innerRef}
                      {...fourni.draggableProps}
                    >
                      <TodoContext.Provider value={{ todo, actions }}>
                        <TodoItem poignee={fourni.dragHandleProps} />
                      </TodoContext.Provider>
                    </li>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </ol>
          )}
        </Droppable>
      </DragDropContext>
      {todos.length > 1 && <p className="tl-aide">Glissez une poignée pour réordonner, ou Espace puis flèches au clavier.</p>}
      <AddTodoForm addTodo={actions.addTodo} />
    </div>
  );
};

export default TodoList;
